module.exports = __webpack_public_path__ + "assets/img/1605_06.jpg?b7930b012e2b4d111ca78cdac71f47db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1605_06.jpg
// module id = 1109
// module chunks = 0